var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-steps-bar"},[_c('yan-progress',{attrs:{"total":100,"done":_vm.done,"modify":_vm.modify,"tip":[
            {
                text: "",
                fillStyle: "#F0F2F6",
            }, {
                text: "",
                fillStyle: "rgba(255, 0, 0, 0.15)",
            }, {
                text: "",
                fillStyle: "#FF0000"
            }
        ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }